import Store from './store';

const lsStore = Store({
    teamMemberSearchQuery: null,
    teamStatusSelection: null,
    teamDateRange: null,
    teamSelectedTeam: null,
}, 'team_tasks_persistence');

export function setTeamMemberSearchQuery (value = null) {
    lsStore.commit('save', {
        key: 'teamMemberSearchQuery',
        value: value,
    });
}

export function getTeamMemberSearchQuery () {
    return lsStore.state.teamMemberSearchQuery;
}

export function setStatusSelection (value = null) {
    lsStore.commit('save', {
        key: 'teamStatusSelection',
        value: value,
    });
}

export function getStatusSelection () {
    return lsStore.state.teamStatusSelection;
}

export function setDateRange (value = null) {
    lsStore.commit('save', {
        key: 'teamDateRange',
        value: value,
    });
}

export function getDateRange () {
    return lsStore.state.teamDateRange;
}

export function setSelectedTeam (value = null) {
    lsStore.commit('save', {
        key: 'teamSelectedTeam',
        value: value,
    });
}

export function getSelectedTeam () {
    return lsStore.state.teamSelectedTeam;
}
